import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, MenuItem } from '@material-ui/core';

function ChangeWorkerDialog({ open, workers, selectedWorker, onClose, onSubmit, onWorkerChange }) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="change-worker-dialog-title">
      <DialogTitle id="change-worker-dialog-title">Change Worker</DialogTitle>
      <DialogContent>
        <TextField
          select
          label="Select Worker"
          value={selectedWorker}
          onChange={(e) => onWorkerChange(e.target.value)}
          fullWidth
        >
          {workers.map((worker) => (
            <MenuItem key={worker.id} value={worker.id}>
              {worker.name}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={() => onSubmit(selectedWorker)} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangeWorkerDialog;
